// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import handshakeIcon from "@/assets/icons/aop/handshake.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type HandshakeIconProps = Omit<IconProps, "name">;

export function HandshakeIcon(props: HandshakeIconProps): React.ReactNode {
  return <Icon name={handshakeIcon} {...props} />;
}
